// Generate random int for altering border radius

export function borderRadGen({ label = "Like this" } = {}) {

    let el = document.getElementById('container');
    let min = 2;
    let max = 48;

    min = Math.ceil(min);
    max = Math.floor(max); // max is exclusive
    //return Math.floor(Math.random() * (max - min)) + min;

    let random_num = Math.floor(Math.random() * (max - min)) + min;
    console.log(random_num);
    let random_num_str = random_num.toString();
    el.style.setProperty('border-radius', random_num_str + 'px');
    // end random num generation for booder radius

    return el;
}